const translations = {};

translations["MSG_APP_ERROR_PASSWORD_CONFIRM_NOT_VALID"] = "密码不匹配。";
translations["MSG_APP_ERROR_PASSWORD_TOO_SHORT"] = "请输入 6 个字符或以上的密码。";
translations["MSG_APP_VERSION_UPDATE_WARNING_MESSAGE"] =
  "应用程序有新版本可用。\n需要更新才能使用最新功能。\n更新将很快完成。";
translations["MSG_APP_VERSION_UPDATE_WARNING_TITLE"] = "正在将应用程序更新至最新版本。";
translations["MSG_ASSISTANT_PLACEHOLDER"] = "输入消息...";
translations["MSG_ASSISTANT_SEND"] = "发送";
translations["MSG_BACK_BTN"] = "返回";
translations["MSG_BACK_BTN_BY_PARENT"] = "返回";
translations["MSG_BIRTHDAY_DAY_SUFFIX_BY_PARENT"] = "日";
translations["MSG_BIRTHDAY_MONTH_SUFFIX_BY_PARENT"] = "月";
translations["MSG_BIRTHDAY_YEAR_SUFFIX_BY_PARENT"] = "年";
translations["MSG_BLOCKLY_INPUT_LENGTH_LIMIT"] = "请输入 %{limit} 个字符以内。";
translations["MSG_BLOCKLY_INPUT_LENGTH_LIMIT_BY_PARENT"] = "%{limit}个字符以内";
translations["MSG_BODY_TYPE_CHUBBY_BY_PARENT"] = "偏胖";
translations["MSG_BODY_TYPE_MEDIUM_BY_PARENT"] = "中等";
translations["MSG_BODY_TYPE_SLIGHTLY_CHUBBY_BY_PARENT"] = "微胖";
translations["MSG_BODY_TYPE_SLIGHTLY_THIN_BY_PARENT"] = "偏瘦";
translations["MSG_BODY_TYPE_THIN_BY_PARENT"] = "瘦";
translations["MSG_BODY_TYPE_TITLE_BY_PARENT"] = "体型";
translations["MSG_BOYS_COUNT"] = "男孩";
translations["MSG_BTN_CLOSE"] = "关闭";
translations["MSG_BTN_LATER"] = "稍后";
translations["MSG_CANCEL_BTN"] = "取消";
translations["MSG_CANCEL_BTN_BY_PARENT"] = "取消";
translations["MSG_CITY_TITLE"] = "城市";
translations["MSG_COLOR_BLUE_BY_PARENT"] = "蓝色";
translations["MSG_COLOR_GREEN_BY_PARENT"] = "绿色";
translations["MSG_COLOR_OTHER_PLACEHOLDER_BY_PARENT"] = "输入自我介绍颜色";
translations["MSG_COLOR_RED_BY_PARENT"] = "红色";
translations["MSG_COLOR_SELECT_SHADE"] = "选择你喜欢的色调";
translations["MSG_COLOR_WHITE_BY_PARENT"] = "白色";
translations["MSG_COLOR_YELLOW_BY_PARENT"] = "黄色";
translations["MSG_COMPANY_SIZE_ENTERPRISE"] = "1001人以上";
translations["MSG_COMPANY_SIZE_LARGE"] = "301-1000人";
translations["MSG_COMPANY_SIZE_MEDIUM"] = "51-300人";
translations["MSG_COMPANY_SIZE_MICRO"] = "1-10人";
translations["MSG_COMPANY_SIZE_SMALL"] = "11-50人";
translations["MSG_COMPANY_SIZE_SOLO"] = "个体经营者";
translations["MSG_COMPANY_SIZE_TITLE"] = "公司规模";
translations["MSG_CONFIRM_BTN_BY_PARENT"] = "确定";
translations["MSG_COURSE_ALGORITHM"] = "学习算法！";
translations["MSG_COURSE_ALGORITHM_ADVANCED"] = "算法进阶";
translations["MSG_COURSE_GROUP_WORK"] = "小组合作";
translations["MSG_COURSE_PROGRAM"] = "编程入门";
translations["MSG_SETTING_COURSE_ANSWER_COURSE_TITLE"] = "选择课程";
translations["MSG_SETTING_COURSE_ANSWER_STAGE_TITLE"] = "选择关卡";
translations["MSG_SETTING_COURSE_ANSWER_LEVEL_TITLE"] = "选择等级";
translations["MSG_SETTING_COURSE_ANSWER_STAGE"] = "关卡";
translations["MSG_SETTING_COURSE_ANSWER_LEVEL"] = "等级";
translations["MSG_ERROR_NETWORK"] = "网络错误";
translations["MSG_FACE_SHAPE_OBLONG_BY_PARENT"] = "长脸";
translations["MSG_FACE_SHAPE_OVAL_BY_PARENT"] = "鹅蛋脸";
translations["MSG_FACE_SHAPE_ROUND_BY_PARENT"] = "圆脸";
translations["MSG_FACE_SHAPE_SQUARE_BY_PARENT"] = "方脸";
translations["MSG_FACE_SHAPE_TITLE_BY_PARENT"] = "脸型";
translations["MSG_FACE_SHAPE_TRIANGLE_BY_PARENT"] = "三角脸";
translations["MSG_GENDER_FEMALE_BY_PARENT"] = "女孩";
translations["MSG_GENDER_MALE_BY_PARENT"] = "男孩";
translations["MSG_GENDER_NONE"] = "无";
translations["MSG_GENERATE_BTN_BY_PARENT"] = "生成";
translations["MSG_GIRLS_COUNT"] = "女孩";
translations["MSG_GLASSES_NONE_BY_PARENT"] = "无";
translations["MSG_GLASSES_TITLE_BY_PARENT"] = "眼镜";
translations["MSG_GLASSES_YES_BY_PARENT"] = "有";
translations["MSG_HAIRSTYLE_LONG_BY_PARENT"] = "长";
translations["MSG_HAIRSTYLE_MEDIUM_BY_PARENT"] = "中等";
translations["MSG_HAIRSTYLE_SHORT_BY_PARENT"] = "短";
translations["MSG_HAIRSTYLE_SLIGHTLY_LONG_BY_PARENT"] = "略长";
translations["MSG_HAIRSTYLE_TITLE_BY_PARENT"] = "发型";
translations["MSG_HAIRSTYLE_VERY_SHORT_BY_PARENT"] = "很短";
translations["MSG_HOUSEHOLD_MEMBERS_TITLE"] = "家庭成员";
translations["MSG_HOUSEHOLD_MEMBER_FATHER"] = "爸爸";
translations["MSG_HOUSEHOLD_MEMBER_GRANDFATHER"] = "爷爷";
translations["MSG_HOUSEHOLD_MEMBER_GRANDMOTHER"] = "奶奶";
translations["MSG_HOUSEHOLD_MEMBER_MOTHER"] = "妈妈";
translations["MSG_ICON_CATEGORY_ALL"] = "全部";
translations["MSG_ICON_CATEGORY_BOY_BY_PARENT"] = "男孩";
translations["MSG_ICON_CATEGORY_GIRL_BY_PARENT"] = "女孩";
translations["MSG_ICON_CHANGE_PREVIEW_CURRENT_PARENT"] = "当前";
translations["MSG_ICON_CHANGE_PREVIEW_SELECTED_PARENT"] = "已选择";
translations["MSG_ICON_CONFIRM_BTN_BY_PARENT"] = "就这个";
translations["MSG_ICON_CONFIRM_PROMPT_BY_PARENT"] = "这个头像可以吗？";
translations["MSG_ICON_GENERATING_BY_PARENT"] = "正在生成头像...";
translations["MSG_ICON_REGENERATE_BTN_BY_PARENT"] = "重新生成";
translations["MSG_ICON_CREATE_BTN"] = "创建";
translations["MSG_ICON_ADDITIONAL_PROMPT_PLACEHOLDER"] = "如果想添加什么";
translations["MSG_ICON_SELECT_PROFILE_AI_BY_PARENT"] = "AI生成";
translations["MSG_ICON_SELECT_SYSTEM_BY_PARENT"] = "预设头像";
translations["MSG_ICON_SELECT_TITLE_BY_PARENT"] = "为孩子选择头像";
translations["MSG_ICON_SELECT_UPLOAD_BY_PARENT"] = "上传图片";
translations["MSG_INDUSTRY_TITLE"] = "行业";
translations["MSG_INDUSTRY_IT"] = "IT・通信";
translations["MSG_INDUSTRY_MANUFACTURING"] = "制造业";
translations["MSG_INDUSTRY_FINANCE"] = "金融・保险";
translations["MSG_INDUSTRY_RETAIL"] = "零售・批发";
translations["MSG_INDUSTRY_HEALTHCARE"] = "医疗・福利";
translations["MSG_INDUSTRY_EDUCATION"] = "教育";
translations["MSG_INDUSTRY_GOVERNMENT"] = "政府・公务员";
translations["MSG_INDUSTRY_REAL_ESTATE"] = "房地产";
translations["MSG_INDUSTRY_CONSTRUCTION"] = "建筑";
translations["MSG_INDUSTRY_TRANSPORTATION"] = "运输・物流";
translations["MSG_INDUSTRY_MEDIA"] = "媒体・广告";
translations["MSG_INDUSTRY_SERVICE"] = "服务业";
translations["MSG_INDUSTRY_OTHER"] = "其他";
translations["MSG_JOB_TITLE_LABEL"] = "职位";
translations["MSG_JOB_TITLE_EXECUTIVE"] = "经营者・高管";
translations["MSG_JOB_TITLE_MANAGER"] = "管理职";
translations["MSG_JOB_TITLE_GENERAL"] = "一般职员";
translations["MSG_JOB_TITLE_PROFESSIONAL"] = "专业职";
translations["MSG_JOB_TITLE_HOMEMAKER"] = "无职位（家庭主妇／主夫）";
translations["MSG_JOB_TITLE_STUDENT"] = "无职位（学生）";
translations["MSG_JOB_TITLE_UNEMPLOYED"] = "无职位（无业）";
translations["MSG_LOADING"] = "加载中...";
translations["MSG_NEXT_BTN_BY_PARENT"] = "下一步";
translations["MSG_NOTIFICATION_DEFAULT_TITLE"] = "通知";
translations["MSG_OCCUPATION_TITLE"] = "职业";
translations["MSG_OCCUPATION_EXECUTIVE"] = "经营・高管";
translations["MSG_OCCUPATION_MANAGER"] = "管理职";
translations["MSG_OCCUPATION_ENGINEER"] = "工程师・技术";
translations["MSG_OCCUPATION_SALES"] = "销售";
translations["MSG_OCCUPATION_MARKETING"] = "市场营销";
translations["MSG_OCCUPATION_HR"] = "人事・行政";
translations["MSG_OCCUPATION_ACCOUNTING"] = "财务・会计";
translations["MSG_OCCUPATION_RESEARCHER"] = "研究・开发";
translations["MSG_OCCUPATION_TEACHER"] = "教师・讲师";
translations["MSG_OCCUPATION_DOCTOR"] = "医生";
translations["MSG_OCCUPATION_NURSE"] = "护士";
translations["MSG_OCCUPATION_LAWYER"] = "律师・法务";
translations["MSG_OCCUPATION_DESIGNER"] = "设计师";
translations["MSG_OCCUPATION_FREELANCE"] = "自由职业";
translations["MSG_OCCUPATION_HOMEMAKER"] = "全职主妇・主夫";
translations["MSG_OCCUPATION_STUDENT"] = "学生";
translations["MSG_OCCUPATION_OTHER"] = "其他";
translations["MSG_PARENTS_CHAT_IMAGE_RESTRICTION_BTN"] = "查看计划";
translations["MSG_PARENTS_CHAT_IMAGE_RESTRICTION_MESSAGE"] =
  "发送图片需要「特别计划」\n升级到特别计划后可以发送图片";
translations["MSG_PARENTS_CHAT_IMAGE_RESTRICTION_TITLE"] = "关于图片功能";
translations["MSG_PARENTS_SHAKE_BUG_REPORT_TITLE"] = "有无法使用的地方吗？";
translations["MSG_PARENTS_SHAKE_SETTING_SECTION_TITLE"] = "问题反馈";
translations["MSG_PARENTS_SHAKE_BUG_REPORT_SEND_FAILED"] = "发送失败。请稍后再试。";
translations["MSG_PARENTS_SHAKE_BUG_REPORT_SENT"] = "已发送给客服，感谢您的反馈。";
translations["MSG_PARENTS_SHAKE_BUG_REPORT_SENDING"] = "发送中…";
translations["MSG_PARENTS_SHAKE_BUG_REPORT_ATTACH_LABEL"] = "一并发送此画面";
translations["MSG_PARENTS_SHAKE_BUG_REPORT_ATTACH_OFF"] = "不发送此画面";
translations["MSG_PARENTS_SHAKE_BUG_REPORT_ATTACH_PICK"] = "选择图片";
translations["MSG_PARENTS_SHAKE_BUG_REPORT_ATTACH_UNDO"] = "撤销";
translations["MSG_PARENTS_SHAKE_BUG_REPORT_ATTACH_REMOVE"] = "移除";
translations["MSG_PARENTS_SHAKE_BUG_REPORT_PLACEHOLDER"] = "请说明哪里、如何无法正常使用。";
translations["MSG_PARENTS_SHAKE_BUG_REPORT_DESCRIPTION"] = "已拍下当前画面。请填写遇到的问题后发送。";
translations["MSG_PARENTS_SHAKE_BUG_REPORT_CAPTURE_LABEL"] = "当前画面";
translations["MSG_PARENTS_SHAKE_BUG_REPORT_BTN"] = "发送给客服";
translations["MSG_PARENTS_SHAKE_BUG_REPORT_TOGGLE_LABEL"] = "摇动告知";
translations["MSG_PARENTS_SHAKE_BUG_REPORT_TOGGLE_DESCRIPTION"] = "关闭后，摇动将不再显示此画面。";
translations["MSG_PARENTS_CHAT_CAPTURE_SCREEN_BTN"] = "截取画面";
translations["MSG_PARENT_ONBOARDING_BIRTHDAY_SELECT"] = "选择";
translations["MSG_PARENT_ONBOARDING_BTN_BACK"] = "返回";
translations["MSG_PARENT_ONBOARDING_BTN_CONFIRM"] = "确认";
translations["MSG_PARENT_ONBOARDING_BTN_GENERATE"] = "创建";
translations["MSG_PARENT_ONBOARDING_BTN_NEXT"] = "下一步";
translations["MSG_PARENT_ONBOARDING_BTN_REGENERATE"] = "重新创建";
translations["MSG_PARENT_ONBOARDING_GENDER_FEMALE"] = "女";
translations["MSG_PARENT_ONBOARDING_GENDER_MALE"] = "男";
translations["MSG_PARENT_ONBOARDING_ICON_METHOD_TITLE"] = "选择头像方式";
translations["MSG_PARENT_ONBOARDING_ICON_PRESET"] = "从预设中选择";
translations["MSG_PARENT_ONBOARDING_ICON_PRESET_TITLE"] = "请选择头像";
translations["MSG_PARENT_ONBOARDING_ICON_PREVIEW_CONFIRM"] = "这个头像可以吗？";
translations["MSG_PARENT_ONBOARDING_ICON_PREVIEW_GENERATING"] = "正在创建头像...";
translations["MSG_PARENT_ONBOARDING_ICON_PROFILE_AI"] = "用AI创建";
translations["MSG_PARENT_ONBOARDING_ICON_UPLOAD"] = "上传图片";
translations["MSG_PARENT_ONBOARDING_INCOME_5M_10M"] = "500-1000万日元";
translations["MSG_PARENT_ONBOARDING_INCOME_OVER_10M"] = "1000万日元以上";
translations["MSG_PARENT_ONBOARDING_INCOME_PREFER_NOT_TO_SAY"] = "不愿透露";
translations["MSG_PARENT_ONBOARDING_INCOME_TITLE"] = "年收入";
translations["MSG_PARENT_ONBOARDING_INCOME_UNDER_5M"] = "500万日元以下";
translations["MSG_PARENT_ONBOARDING_UPLOAD_HINT"] = "JPG、PNG格式，最大5MB";
translations["MSG_PARENT_ONBOARDING_UPLOAD_SELECT"] = "选择图片";
translations["MSG_PARENT_ONBOARDING_UPLOAD_TITLE"] = "上传图片";
translations["MSG_PARENT_PAGE_ACCOUNT_ACTIONS"] = "账号操作";
translations["MSG_PARENT_PAGE_ACCOUNT_CREATED_DATE"] = "账号创建日期";
translations["MSG_PARENT_PAGE_ACCOUNT_INFO"] = "账号信息";
translations["MSG_PARENT_PAGE_ACCOUNT_STATUS"] = "账号状态";
translations["MSG_PARENT_PAGE_ACTIVE"] = "活跃";
translations["MSG_PARENT_PAGE_ACTIVITY_AI_CHAT"] = "和学伴君聊天了";
translations["MSG_PARENT_PAGE_ACTIVITY_APP_REVIEWED"] = "给应用评了★%{rating}";
translations["MSG_PARENT_PAGE_ACTIVITY_COURSE_CLEAR"] =
  "通过了%{course}的阶段%{stage} 等级%{level}！";
translations["MSG_PARENT_PAGE_ACTIVITY_DEFAULT"] = "活动";
translations["MSG_PARENT_PAGE_ACTIVITY_FAVORITED_RECEIVED"] = "收到了点赞";
translations["MSG_PARENT_PAGE_ACTIVITY_FEEDBACK_SENT"] = "发送了反馈";
translations["MSG_PARENT_PAGE_ACTIVITY_ICON_CHANGED"] = "更换了头像";
translations["MSG_PARENT_PAGE_ACTIVITY_INQUIRY_SENT"] = "发送了问题反馈";
translations["MSG_PARENT_PAGE_ACTIVITY_LOGIN"] = "登录了";
translations["MSG_PARENT_PAGE_ACTIVITY_PROJECT_CREATED"] = "创建了「%{name}」";
translations["MSG_PARENT_PAGE_ACTIVITY_PROJECT_FAVORITED"] = "给「%{name}」点了赞";
translations["MSG_PARENT_PAGE_ACTIVITY_PROJECT_PUBLISHED"] = "发布了「%{name}」";
translations["MSG_PARENT_PAGE_ADD"] = "添加";
translations["MSG_PARENT_PAGE_ADD_CHILD_LIMIT_MESSAGE"] = "已达到最大用户数";
translations["MSG_PARENT_PAGE_ADD_CHILD_LIMIT_TITLE"] = "无法添加用户";
translations["MSG_PARENT_PAGE_AGE"] = "年龄";
translations["MSG_PARENT_PAGE_AI_CHAT"] = "与学伴君聊天";
translations["MSG_PARENT_PAGE_AI_CHAT_BENEFIT_1"] = "回答问题和咨询";
translations["MSG_PARENT_PAGE_AI_CHAT_BENEFIT_2"] = "培养孩子好奇心的对话体验";
translations["MSG_PARENT_PAGE_AI_CHAT_BENEFIT_3"] = "可以讨论想法";
translations["MSG_PARENT_PAGE_AI_CHAT_FEATURE"] = "与学伴君聊天";
translations["MSG_PARENT_PAGE_AI_CHAT_FREE_LIMIT"] = "8次/日";
translations["MSG_PARENT_PAGE_AI_CHAT_HISTORY"] = "AI聊天记录";
translations["MSG_PARENT_PAGE_AI_CHAT_HISTORY_EMPTY"] = "暂无聊天记录";
translations["MSG_PARENT_PAGE_AI_CHAT_MESSAGE_COUNT"] = "%{count}条消息";
translations["MSG_PARENT_PAGE_AI_CHAT_NO_MESSAGES"] = "暂无消息";
translations["MSG_PARENT_PAGE_AI_CHAT_NO_TITLE"] = "无标题";
translations["MSG_PARENT_PAGE_AI_CHAT_PREMIUM_LIMIT"] = "无限制";
translations["MSG_PARENT_PAGE_AI_CHAT_STANDARD_LIMIT"] = "无限制";
translations["MSG_PARENT_PAGE_AI_CHAT_TAGLINE"] = "与AI角色愉快聊天！";
translations["MSG_PARENT_PAGE_AI_GENERATION"] = "AI创作素材";
translations["MSG_PARENT_PAGE_SHAKE_BUG_REPORT"] = "摇动告知";
translations["MSG_PARENT_PAGE_AI_IMAGE_BENEFIT_1"] = "创建原创图标";
translations["MSG_PARENT_PAGE_AI_IMAGE_BENEFIT_2"] = "用于「自由创作」";
translations["MSG_PARENT_PAGE_AI_IMAGE_BENEFIT_3"] = "也可发送到聊天";
translations["MSG_PARENT_PAGE_AI_IMAGE_FEATURE"] = "AI素材图像生成";
translations["MSG_PARENT_PAGE_AI_IMAGE_FREE_LIMIT"] = "2次/日";
translations["MSG_PARENT_PAGE_AI_IMAGE_PREMIUM_LIMIT"] = "无限制（同时生成3张）";
translations["MSG_PARENT_PAGE_AI_IMAGE_STANDARD_LIMIT"] = "10次/日";
translations["MSG_PARENT_PAGE_AI_IMAGE_TAGLINE"] = "将想象变成图像！";
translations["MSG_PARENT_PAGE_APPLE_ID"] = "Apple ID";
translations["MSG_PARENT_PAGE_APP_DESCRIPTION"] = "使用家长应用查看孩子的学习进度并管理设置。";
translations["MSG_PARENT_PAGE_BASIC_INFO"] = "基本信息";
translations["MSG_PARENT_PAGE_BILLING_PERIOD"] = "计费周期";
translations["MSG_PARENT_PAGE_BIRTHDAY"] = "生日";
translations["MSG_PARENT_PAGE_BIRTHDAY_EDIT_TITLE"] = "修改生日";
translations["MSG_PARENT_PAGE_CHANGE"] = "更改";
translations["MSG_PARENT_PAGE_CHANGE_PASSWORD"] = "修改密码";
translations["MSG_PARENT_PAGE_STORAGE_FEATURE"] = "数据存储容量";
translations["MSG_PARENT_PAGE_STORAGE_FREE_LIMIT"] = "1GB";
translations["MSG_PARENT_PAGE_STORAGE_STANDARD_LIMIT"] = "5GB";
translations["MSG_PARENT_PAGE_STORAGE_PREMIUM_LIMIT"] = "50GB";
translations["MSG_PARENT_PAGE_PLAYER_AI_IMAGE"] = "AI图片";
translations["MSG_PARENT_PAGE_PLAYER_ALBUM"] = "相册";
translations["MSG_PARENT_PAGE_PLAYER_ASSETS"] = "素材列表";
translations["MSG_PARENT_PAGE_PLAYER_ASSETS_EMPTY"] = "还没有素材";
translations["MSG_PARENT_PAGE_PLAYER_ASSETS_LIST"] = "素材列表";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_CREATED"] = "创建日期";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_SIZE"] = "尺寸";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_UNNAMED"] = "未命名";
translations["MSG_PARENT_PAGE_PLAYER_PROJECTS"] = "应用列表";
translations["MSG_PARENT_PAGE_PLAYER_PROJECTS_EMPTY"] = "还没有应用";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_COPIES"] = "次复制";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_CREATED"] = "创建日期";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_LIKES"] = "个赞";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_PUBLISHED"] = "已发布";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_UNPUBLISHED"] = "未公开";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_UPDATED"] = "更新日期";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_VIEWS"] = "次浏览";
translations["MSG_PARENT_PAGE_PLAYER_SHOW_MORE"] = "查看更多";
translations["MSG_PARENT_PAGE_PLAYER_SKETCHBOOK"] = "画板";
translations["MSG_PARENT_PAGE_CHILD_NAME_EDIT_MESSAGE"] = "请输入新名字";
translations["MSG_PARENT_PAGE_CHILD_NAME_EDIT_TITLE"] = "修改名字";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_BUG"] = "问题报告";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_HOW_TO"] = "使用方法";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_OTHER"] = "自我介绍";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_REQUEST"] = "功能请求";
translations["MSG_PARENT_PAGE_COPY_PERMISSION"] = "复制许可";
translations["MSG_PARENT_PAGE_CORPORATE_ALLOWED_CONTENT"] = "已授权的内容（卡带）";
translations["MSG_PARENT_PAGE_CORPORATE_AUTH_CODE_INPUT"] = "输入认证码";
translations["MSG_PARENT_PAGE_CORPORATE_AUTH_DESCRIPTION"] =
  "如果您持有「乐学拼图」认证码（企业合作码），请在下方输入指定的代码。";
translations["MSG_PARENT_PAGE_CORPORATE_CODE"] = "企业合作代码";
translations["MSG_PARENT_PAGE_CORPORATE_CONFIRM"] = "确定";
translations["MSG_PARENT_PAGE_CORPORATE_DESCRIPTION"] = "如果您有企业合作代码，请在这里输入。";
translations["MSG_PARENT_PAGE_CORPORATE_NO_CONTENT"] = "没有已授权的追加内容（卡带）。";
translations["MSG_PARENT_PAGE_COURSE_ANSWER"] = "查看课程答案";
translations["MSG_PARENT_PAGE_COURSE_CLEAR"] = "课程完成";
translations["MSG_PARENT_PAGE_CREATED_AT"] = "注册日期";
translations["MSG_PARENT_PAGE_CREATED_PROJECTS"] = "创建的作品";
translations["MSG_PARENT_PAGE_CURRENT_PLAN"] = "当前方案";
translations["MSG_PARENT_PAGE_DANGER_ZONE"] = "危险操作";
translations["MSG_PARENT_PAGE_DATE_FORMAT"] = "MM月DD日";
translations["MSG_PARENT_PAGE_DAY"] = "日";
translations["MSG_PARENT_PAGE_DELETE_BTN"] = "删除";
translations["MSG_PARENT_PAGE_DELETE_CHILD"] = "删除此用户";
translations["MSG_PARENT_PAGE_DELETE_CHILD_MESSAGE"] = "此操作无法撤销";
translations["MSG_PARENT_PAGE_DELETE_CHILD_MIN_MESSAGE"] = "至少需要一个用户";
translations["MSG_PARENT_PAGE_DELETE_CHILD_MIN_TITLE"] = "无法删除用户";
translations["MSG_PARENT_PAGE_DELETE_CHILD_TITLE"] = "删除用户？";
translations["MSG_PARENT_PAGE_DELETE_CHILD_WARNING"] =
  "所有学习数据和作品将被删除。此操作无法撤销。";
translations["MSG_PARENT_PAGE_DISPLAY_LANGUAGE"] = "显示语言";
translations["MSG_PARENT_PAGE_DOWNLOAD_PARENTS_APP"] = "下载家长应用";
translations["MSG_PARENT_PAGE_DOWNLOAD_KIDS_APP"] = "下载Manapazu";
translations["MSG_PARENT_PAGE_KIDS_APP_DESCRIPTION"] = "使用Manapazu应用与孩子一起享受学习的乐趣。";
translations["MSG_PARENT_PAGE_EDIT_BEST_SUBJECT"] = "编辑擅长科目";
translations["MSG_PARENT_PAGE_EDIT_BODY_TYPE"] = "编辑体型";
translations["MSG_PARENT_PAGE_EDIT_FACE_SHAPE"] = "编辑脸型";
translations["MSG_PARENT_PAGE_EDIT_FAVORITE_COLOR"] = "编辑喜欢的颜色";
translations["MSG_PARENT_PAGE_EDIT_GLASSES"] = "编辑眼镜";
translations["MSG_PARENT_PAGE_EDIT_HAIRSTYLE"] = "编辑发型";
translations["MSG_PARENT_PAGE_EDIT_SELF_INTRO"] = "编辑自我介绍";
translations["MSG_PARENT_PAGE_EDUCATION_DESCRIPTION"] = "您正在使用企业合同。详情请联系管理员。";
translations["MSG_PARENT_PAGE_EMAIL"] = "邮箱地址";
translations["MSG_PARENT_PAGE_EMAIL_VERIFIED"] = "邮箱验证";
translations["MSG_PARENT_PAGE_ENABLE_CORPORATE"] = "输入企业认证代码";
translations["MSG_PARENT_PAGE_FEEDBACK_DETAIL"] = "反馈详情";
translations["MSG_PARENT_PAGE_FEEDBACK_HISTORY"] = "反馈历史";
translations["MSG_PARENT_PAGE_FEEDBACK_HISTORY_EMPTY"] = "还没有反馈";
translations["MSG_PARENT_PAGE_FEEDBACK_PENDING"] = "未回复";
translations["MSG_PARENT_PAGE_FEEDBACK_RATING_SUMMARY"] = "给应用评了★%{rating}";
translations["MSG_PARENT_PAGE_FEEDBACK_REPLIED"] = "已回复";
translations["MSG_PARENT_PAGE_FEEDBACK_TYPE_CONTACT"] = "咨询";
translations["MSG_PARENT_PAGE_FEEDBACK_TYPE_FEEDBACK"] = "反馈";
translations["MSG_PARENT_PAGE_FEEDBACK_TYPE_RATING"] = "应用评价";
translations["MSG_PARENT_PAGE_FROZEN_DIALOG_MESSAGE"] =
  "该玩家已停用，无法切换登录。请先激活玩家。";
translations["MSG_PARENT_PAGE_FROZEN_DIALOG_TITLE"] = "无法切换";
translations["MSG_PARENT_PAGE_GENDER"] = "性别";
translations["MSG_PARENT_PAGE_GENDER_EDIT_TITLE"] = "修改性别";
translations["MSG_PARENT_PAGE_GOOGLE_ACCOUNT"] = "Google账号";
translations["MSG_PARENT_PAGE_HIRAGANA"] = "平假名";
translations["MSG_PARENT_PAGE_ICON"] = "头像";
translations["MSG_PARENT_PAGE_INACTIVE"] = "非活跃";
translations["MSG_PARENT_PAGE_KANJI"] = "汉字";
translations["MSG_PARENT_PAGE_LANGUAGE_EDIT_MESSAGE"] = "选择显示语言";
translations["MSG_PARENT_PAGE_LANGUAGE_EDIT_TITLE"] = "更改语言";
translations["MSG_PARENT_PAGE_LANGUAGE_EN"] = "英语";
translations["MSG_PARENT_PAGE_LANGUAGE_JA"] = "日语";
translations["MSG_PARENT_PAGE_LANGUAGE_ZH_CN"] = "简体中文";
translations["MSG_PARENT_PAGE_LANGUAGE_ZH_TW"] = "繁体中文";
translations["MSG_PARENT_PAGE_LEARNING_SUPPORT"] = "学习支持";
translations["MSG_PARENT_PAGE_LINK"] = "绑定";
translations["MSG_PARENT_PAGE_LOGOUT"] = "退出登录";
translations["MSG_PARENT_PAGE_MESSAGE_INPUT_PLACEHOLDER"] = "输入消息...";
translations["MSG_PARENT_PAGE_MESSAGE_LOAD_MORE"] = "加载更多";
translations["MSG_PARENT_PAGE_MESSAGE_NO_MESSAGES"] = "暂无消息";
translations["MSG_PARENT_PAGE_MESSAGE_NO_ROOMS"] = "没有聊天室";
translations["MSG_INEXUS_OFFICIAL_CONTACT"] = "樂學拼圖 支持";
translations["MSG_PARENT_PAGE_SUPPORT_WELCOME"] =
  "这里是『樂學拼圖』支持窗口。\n如有任何疑问、故障或需求，请在此给我们留言。";
translations["MSG_USER_PROFILE_MESSAGE_CONTACT_INPUT_AUTO_REPLY"] =
  "感谢您的询问！\n请在下方的输入字段中填写您的问题。";
translations["MSG_PARENT_PAGE_MONTH"] = "月";
translations["MSG_PARENT_PAGE_NICKNAME"] = "昵称";
translations["MSG_PARENT_PAGE_NICKNAME_EDIT_MESSAGE"] = "请输入新的昵称";
translations["MSG_PARENT_PAGE_NICKNAME_EDIT_TITLE"] = "修改昵称";
translations["MSG_PARENT_PAGE_NICKNAME_ERROR_MESSAGE"] = "请尝试自我介绍名称";
translations["MSG_PARENT_PAGE_NOT_SET"] = "未设置";
translations["MSG_PARENT_PAGE_NO_ACTIVITY_24H"] = "24小时内暂无活动";
translations["MSG_PARENT_PAGE_PEOPLE"] = "人";
translations["MSG_PARENT_PAGE_PLAN_COMPARISON"] = "方案对比";
translations["MSG_PARENT_PAGE_PLAN_INFO"] = "套餐信息";
translations["MSG_PARENT_PAGE_PLAN_SCOPE_ACCOUNT"] = "账户整体";
translations["MSG_PARENT_PAGE_PLAN_SCOPE_PLAYER"] = "每位玩家";
translations["MSG_PARENT_PAGE_PLAYABLE"] = "可游玩";
translations["MSG_PARENT_PAGE_PROFILE_BASIC_INFO"] = "基本信息";
translations["MSG_PARENT_PAGE_PROFILE_NOTES"] = "自我介绍备注";
translations["MSG_PARENT_PAGE_PROFILE_NOT_SET"] = "未设置";
translations["MSG_PARENT_PAGE_PROFILE_SECTION_TITLE"] = "个人资料";
translations["MSG_PARENT_PAGE_USAGE_SECTION_TITLE"] = "使用情况";
translations["MSG_PARENT_PAGE_USAGE_PLAYERS"] = "玩家数";
translations["MSG_PARENT_PAGE_USAGE_STORAGE"] = "数据存储容量";
translations["MSG_PARENT_PAGE_USAGE_CHAT_HISTORY"] = "聊天记录";
translations["MSG_PARENT_PAGE_USAGE_ITEMS"] = "条";
translations["MSG_PARENT_PAGE_PROFILE_UPDATE_ERROR"] = "个人资料更新失败";
translations["MSG_PARENT_PAGE_PROFILE_UPDATE_SUCCESS"] = "个人资料更新成功";
translations["MSG_PARENT_PAGE_PROJECTS"] = "个作品";
translations["MSG_PARENT_PAGE_PROJECT_COUNT"] = '"自由创作"作品数';
translations["MSG_PARENT_PAGE_PROJECT_PUBLISH"] = "作品公开";
translations["MSG_PARENT_PAGE_PUBLISHED_PROJECTS"] = "已发布作品";
translations["MSG_PARENT_PAGE_RECEIVED_LIKES"] = "获得的点赞";
translations["MSG_PARENT_PAGE_RECENT_ACTIVITY"] = "最近活动";
translations["MSG_PARENT_PAGE_RECENT_ACTIVITY_24H"] = "最近24小时的活动";
translations["MSG_PARENT_PAGE_SETTINGS"] = "设置";
translations["MSG_PARENT_PAGE_SNS_LINK"] = "账号绑定";
translations["MSG_PARENT_PAGE_SUBSCRIPTION_SOURCE"] = "购买方式";
translations["MSG_PARENT_PAGE_SUSPENDED"] = "已暂停";
translations["MSG_PARENT_PAGE_SWITCH_CONFIRM_MESSAGE"] = "切换到「%{name}」。";
translations["MSG_PARENT_PAGE_SWITCH_CONFIRM_TITLE"] = "切换玩家？";
translations["MSG_PARENT_PAGE_SWITCH_LOGIN"] = "切换";
translations["MSG_PARENT_PAGE_TAB_ACCOUNT"] = "家长账号";
translations["MSG_PARENT_PAGE_TAB_APPEARANCE"] = "头像";
translations["MSG_PARENT_PAGE_TAB_BASIC"] = "基本信息";
translations["MSG_PARENT_PAGE_TAB_PLAYER"] = "玩家管理";
translations["MSG_PARENT_PAGE_TAB_FAVORITES"] = "个性";
translations["MSG_PARENT_PAGE_TAB_MESSAGE"] = "消息";
translations["MSG_PARENT_PAGE_TAB_NOTIFICATION"] = "通知";
translations["MSG_PARENT_PAGE_TAB_OTHER"] = "其他";
translations["MSG_PARENT_PAGE_TAB_SUBSCRIPTION"] = "订阅管理";
translations["MSG_PARENT_PAGE_TODAY"] = "今天";
translations["MSG_PARENT_PAGE_UNLIMITED"] = "无限制";
translations["MSG_PARENT_PAGE_UNLINK"] = "解除绑定";
translations["MSG_PARENT_PAGE_UPGRADE_SECTION"] = "购买套餐";
translations["MSG_PARENT_PAGE_USER_COUNT"] = "玩家数";
translations["MSG_PARENT_PAGE_VERIFIED"] = "已验证";
translations["MSG_PARENT_PAGE_VIEW_TUTORIAL"] = "查看教程";
translations["MSG_PARENT_PAGE_YEAR"] = "年";
translations["MSG_PARENT_PAGE_YEARS_OLD"] = "岁";
translations["MSG_PARENT_PAGE_YESTERDAY"] = "昨天";
translations["MSG_PARENT_PROFILE_APPEARANCE"] = "头像";
translations["MSG_PARENT_PROFILE_FAMILY"] = "家庭";
translations["MSG_PARENT_PROFILE_REGION"] = "地区";
translations["MSG_PARENT_PROFILE_WORK"] = "工作";
translations["MSG_PLAN_BUILDER_PARENT"] = "创作者";
translations["MSG_PLAN_EDUCATION_PARENT"] = "教室";
translations["MSG_PLAN_FREE_FULL_PARENT"] = "免费套餐";
translations["MSG_PLAN_TRIAL_PARENT"] = "体验";
translations["MSG_PLAN_FREE_PARENT"] = "免费";
translations["MSG_PLAN_PREMIUM_FULL_PARENT"] = "高级套餐";
translations["MSG_PLAN_PREMIUM_PARENT"] = "高级";
translations["MSG_PLAN_STANDARD_FULL_PARENT"] = "基本套餐";
translations["MSG_PLAN_STANDARD_PARENT"] = "基本";
translations["MSG_PREFECTURE_TITLE"] = "省份";
translations["MSG_PROFILE_AI_BEST_SUBJECTS_BY_PARENT"] = "擅长科目";
translations["MSG_PROFILE_AI_BODY_TYPE_BY_PARENT"] = "体型";
translations["MSG_PROFILE_AI_FACE_SHAPE_BY_PARENT"] = "脸型";
translations["MSG_PROFILE_AI_FAVORITE_COLOR_PARENT"] = "喜欢的颜色";
translations["MSG_PROFILE_AI_GLASSES"] = "眼镜";
translations["MSG_PROFILE_AI_HAIRSTYLE_BY_PARENT"] = "发型";
translations["MSG_PROFILE_AI_OTHER_INFO_PLACEHOLDER_BY_PARENT"] = "请介绍一下您的孩子";
translations["MSG_PROFILE_SUBSTEP_BIRTHDAY_BY_PARENT"] = "生日";
translations["MSG_PROFILE_SUBSTEP_GENDER_BY_PARENT"] = "性别";
translations["MSG_PROFILE_SUBSTEP_ICON_BY_PARENT"] = "头像";
translations["MSG_PROFILE_STEP_GENDER_DESC"] = "请选择您的性别。";
translations["MSG_PROFILE_STEP_BIRTHDAY_DESC"] = "请选择您的生日。";
translations["MSG_PROFILE_STEP_APPEARANCE_DESC"] = "请从选项中选择最接近的。";
translations["MSG_PROFILE_STEP_WORK_DESC"] = "请选择您的工作信息。";
translations["MSG_PROFILE_STEP_REGION_DESC"] = "请选择您所在的都道府县和地区。";
translations["MSG_PROFILE_STEP_FAMILY_DESC"] = "请选择同住的家庭成员（可多选）";
translations["MSG_QR_LOGIN_ISSUE_BTN"] = "扫描二维码";
translations["MSG_QR_LOGIN_ISSUE_CODE_LABEL"] = "登录代码";
translations["MSG_QR_LOGIN_ISSUE_DESC"] =
  "在想要登录的设备上，打开登录页面的「用二维码登录」，扫描此二维码或输入代码。";
translations["MSG_QR_LOGIN_ISSUE_ERROR"] = "代码生成失败。请稍后再试。";
translations["MSG_QR_LOGIN_ISSUE_EXPIRED"] = "此代码已过期。";
translations["MSG_QR_LOGIN_ISSUE_EXPIRES_IN"] = "有效期：剩余 %{time}";
translations["MSG_QR_LOGIN_ISSUE_REGENERATE"] = "生成新代码";
translations["MSG_QR_LOGIN_ISSUE_TITLE"] = "用二维码登录";
translations["MSG_QR_LOGIN_ISSUE_WARNING"] =
  "请勿将此代码告诉他人。知道此代码的人可以登录此账户。";
translations["MSG_QR_LOGIN_SCAN_BTN"] = "用二维码登录";
translations["MSG_AUTH_OR_DIVIDER"] = "或";
translations["MSG_QR_LOGIN_SCAN_CAMERA_ERROR"] = "无法启动相机。请输入代码。";
translations["MSG_QR_LOGIN_SCAN_DESC"] = "请扫描已登录设备上显示的二维码。";
translations["MSG_QR_LOGIN_SCAN_INVALID"] = "代码无效或已过期。\n请重试。";
translations["MSG_QR_LOGIN_SCAN_MANUAL_DESC"] =
  "无法使用相机时，请输入显示的代码。";
translations["MSG_QR_LOGIN_SCAN_MANUAL_LABEL"] = "输入代码";
translations["MSG_QR_LOGIN_SCAN_SUBMIT"] = "登录";
translations["MSG_QR_LOGIN_SCAN_TITLE"] = "用二维码登录";
translations["MSG_QR_LOGIN_SWITCH_TO_SCAN"] = "扫描二维码";
translations["MSG_QR_LOGIN_DISPLAY_DESC"] =
  "请用已登录的「乐学拼图」或家长应用扫描此二维码，并允许登录。";
translations["MSG_QR_LOGIN_WAITING"] = "正在等待允许…";
translations["MSG_QR_LOGIN_APPROVE_TITLE"] = "允许其他设备登录";
translations["MSG_QR_LOGIN_APPROVE_DESC"] =
  "请扫描想要登录的设备上显示的二维码，或输入其代码。";
translations["MSG_QR_LOGIN_APPROVE_CONFIRM"] = "要登录吗？";
translations["MSG_QR_LOGIN_APPROVE_CONFIRM_DESC"] =
  "如果没有印象，\n请关闭此画面。\n要使用%{app}，\n请点按［登录］。";
translations["MSG_QR_LOGIN_APP_NAME_KIDS"] = "「乐学拼图」";
translations["MSG_QR_LOGIN_APP_NAME_PARENTS"] = "家长应用";
translations["MSG_QR_LOGIN_APPROVE_SUCCESS"] = "已允许登录。";
translations["MSG_REAUTH_BACK"] = "返回";
translations["MSG_REAUTH_PASSWORD_RESET_CONFIRM"] = "将向以下邮箱发送密码重置邮件";
translations["MSG_REAUTH_SSO_MESSAGE"] = "请再次登录以继续";
translations["MSG_REAUTH_TITLE"] = "身份验证";
translations["MSG_RESTRICTED_FEATURE_BTN_VIEW_PLANS"] = "查看计划";
translations["MSG_REVIEW_FEEDBACK_TYPE_APP_HARD_TO_USE"] = "难以使用";
translations["MSG_REVIEW_FEEDBACK_TYPE_APP_HOW_TO_USE"] = "不知道\n如何使用";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_DIFFICULT"] = "太难";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_EASY"] = "太简单";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_FEW"] = "关卡\n太少";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_MANY"] = "关卡\n太多";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR_HARD_TO_CREATE"] = "无法\n顺利创作";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR_HARD_TO_USE"] = "难以\n使用";
translations["MSG_REVIEW_FEEDBACK_TYPE_NONE"] = "没有抱怨";
translations["MSG_SELECT_PLACEHOLDER_BY_PARENT"] = "请选择";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_ACTIVE_WARNING_MESSAGE"] =
  "无法暂停当前登录的用户。\n请先切换到其他用户，然后再暂停此用户。";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_ACTIVE_WARNING_TITLE"] = "无法更改";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MAX_WARNING_MESSAGE"] =
  "最多只能有 4 位活动用户。\n若要启用此用户，请先停用（或删除）另一位不需要的用户。";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MAX_WARNING_TITLE"] = "无法启用";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MIN_WARNING_MESSAGE"] =
  "至少需要一位用户。\n无法再减少用户数量。";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MIN_WARNING_TITLE"] = "无法更改";
translations["MSG_SETTING_PARENTS_DISABLE_KIDS_USER_MESSAGE"] = "暂停此用户的游玩。";
translations["MSG_SETTING_PARENTS_DISABLE_KIDS_USER_TITLE"] = "暂停游玩";
translations["MSG_SETTING_PARENTS_ENABLE_KIDS_USER_MESSAGE"] = "恢复此用户的游玩。";
translations["MSG_SETTING_PARENTS_ENABLE_KIDS_USER_TITLE"] = "恢复游玩";
translations["MSG_SETTING_PARENTS_LINK_ADD_USER_AUTH_CODE_TITLE"] = "验证码";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_LINK_ALREADY_ERROR_MESSAGE"] =
  "社交账户已链接到另一个账户。";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_LINK_ALREADY_ERROR_TITLE"] = "无法链接";
translations["MSG_SETTING_PARENTS_USER_PROFILE_UNSUBSCRIBE_BTN"] = "删除账户";
translations["MSG_SETTING_PARENTS_USER_SIGN_OUT_MESSAGE"] =
  "登出账户后，您将无法使用当前的用户游玩。\n用户信息已保存在账户中，如果您想再次使用相同的用户游玩，请使用此账户重新登录。";
translations["MSG_SETTING_PARENTS_USER_SIGN_OUT_TITLE"] = "登出";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_FORM_TITLE"] = "请告诉我们删除账户的原因。";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_MESSAGE"] =
  "删除账户将移除所有数据，包括账户和用户。\n账户删除后无法恢复。请小心操作。";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_TITLE"] = "您确定要删除账户吗？";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_WARNING_MESSAGE"] =
  "从'乐学拼图'删除您的账户将删除以下所有数据：\n・注册的个人资料和账户信息。\n・所有已注册的用户信息。\n・用户在「自由创作」中创建的应用程序。\n・用户在「通过课程学习」中完成的所有成绩和成就。\n・用户进行的「对话记录」等。\n* 【重要】删除已登录的账户将删除与此账户相关的所有数据，请务必小心。\n* 【重要】此操作在任何情况下都无法恢复。删除账户时请务必小心。";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_WARNING_TITLE"] = "【重要】请注意";
translations["MSG_SETTING_TITLE_CORPORATE_AUTH"] = "企业合作认证";
translations["MSG_SETTING_TITLE_COURSE_ANSWER"] = "查看课程答案";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_CURRENT_PASSWORD"] = "当前密码";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_NEW_PASSWORD"] = "新密码";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_NEW_PASSWORD_CONFIRM"] = "确认密码";
translations["MSG_SIGN_EMAIL_SENT"] = "邮件已发送";
translations["MSG_SIGN_IN_BTN"] = "登录";
translations["MSG_SIGN_IN_CHANGE_PASSWORD_CURRENT_PASSWORD_WRONG"] = "输入的密码不正确。";
translations["MSG_SIGN_IN_CHANGE_PASSWORD_SUCCESS_CONTENT"] = "密码更改成功。";
translations["MSG_SIGN_IN_FAILED_MESSAGE"] = "电子邮件地址或密码不正确。";
translations["MSG_SIGN_IN_FAILED_TITLE"] = "登录失败";
translations["MSG_SIGN_IN_FORGOT_PASSWORD"] = "忘记密码？";
translations["MSG_SIGN_IN_SUCCESS_CONTENT"] = "登录成功。";
translations["MSG_SIGN_IN_WITH_APPLE"] = "使用 Apple 继续";
translations["MSG_SIGN_IN_WITH_GOOGLE"] = "使用 Google 继续";
translations["MSG_SIGN_PASSWORD_RESET_FAILED"] = "密码重置邮件发送失败。请重试。";
translations["MSG_SIGN_PASSWORD_RESET_SEND_BTN"] = "发送重置邮件";
translations["MSG_SIGN_PASSWORD_RESET_DESCRIPTION"] = "将向以下电子邮件地址发送密码重置邮件。";
translations["MSG_SIGN_PASSWORD_RESET_SENT"] = "已发送密码重置邮件。";
translations["MSG_CLOSE_BTN_BY_PARENT"] = "关闭";
translations["MSG_SIGN_USER_PASSWORD"] = "密码";
translations["MSG_SUBJECT_ART_BY_PARENT"] = "美术";
translations["MSG_SUBJECT_ENGLISH_BY_PARENT"] = "英语";
translations["MSG_SUBJECT_ETHICS_BY_PARENT"] = "道德";
translations["MSG_SUBJECT_HOME_EC_BY_PARENT"] = "家政";
translations["MSG_SUBJECT_JAPANESE_BY_PARENT"] = "日语";
translations["MSG_SUBJECT_MATH_BY_PARENT"] = "数学";
translations["MSG_SUBJECT_MUSIC_BY_PARENT"] = "音乐";
translations["MSG_SUBJECT_PE_BY_PARENT"] = "体育";
translations["MSG_SUBJECT_PROGRAMMING_BY_PARENT"] = "编程";
translations["MSG_SUBJECT_SCIENCE_BY_PARENT"] = "科学";
translations["MSG_SUBJECT_SOCIAL_BY_PARENT"] = "社会";
translations["MSG_SUBSCRIPTION_ANNUAL_LABEL"] = "年付";
translations["MSG_SUBSCRIPTION_ANNUAL_BADGE"] = "立省 2 个月！";
translations["MSG_SUBSCRIPTION_ANNUAL_TITLE"] = "年订阅";
translations["MSG_SUBSCRIPTION_DISCOUNT_BADGE"] = "家庭补贴";
translations["MSG_SUBSCRIPTION_MANAGE"] = "管理订阅";
translations["MSG_SUBSCRIPTION_MANAGE_APP_STORE_MESSAGE"] = "请在App Store管理您购买的订阅";
translations["MSG_SUBSCRIPTION_MANAGE_PLAY_STORE_MESSAGE"] = "请在Google Play管理您购买的订阅";
translations["MSG_SUBSCRIPTION_MONTHLY_LABEL"] = "月付";
translations["MSG_SUBSCRIPTION_MONTHLY_TITLE"] = "月订阅";
translations["MSG_SUBSCRIPTION_PLATFORM_MISMATCH_MESSAGE"] = "此订阅是在其他平台购买的";
translations["MSG_SUBSCRIPTION_PLATFORM_MISMATCH_TITLE"] = "在其他平台购买";
translations["MSG_SUBSCRIPTION_PORTAL_ERROR"] = "无法打开入口";
translations["MSG_SUBSCRIPTION_PURCHASE_BTN"] = "购买";
translations["MSG_SUBSCRIPTION_PURCHASE_ERROR"] = "购买失败，请重试。";
translations["MSG_SUBSCRIPTION_PURCHASE_SUCCESS"] = "购买成功！";
translations["MSG_SUBSCRIPTION_STORE_MANAGE_TITLE"] = "订阅管理";
translations["MSG_TOAST_DELETED_SUCCESS"] = "删除成功";
translations["MSG_TOAST_EDIT_SUCCESS"] = "更改成功";
translations["MSG_TOAST_ERROR"] = "发生错误";
translations["MSG_TOAST_FILE_TOO_LARGE"] = "文件太大";
translations["MSG_TOAST_SEND_FAILED"] = "发送失败";
translations["MSG_UPLOAD_ICON_HINT_BY_PARENT"] = "JPG、PNG格式，最大5MB";
translations["MSG_UPLOAD_ICON_SELECT_BY_PARENT"] = "选择图片";
translations["MSG_UPLOAD_ICON_TITLE_BY_PARENT"] = "上传图片";
translations["MSG_USER_NAME_LENGTH_LIMIT"] = "请输入10个字符以内的姓名";
translations["MSG_USER_NAME_REQUIRED"] = "请输入姓名";
translations["MSG_PARENT_PAGE_PLAYER_EMPTY_TITLE"] = "没有玩家";
translations["MSG_PARENT_PAGE_PLAYER_EMPTY_MESSAGE"] = "添加孩子开始学习";
translations["MSG_PARENT_PAGE_PLAYER_ADD_BTN"] = "添加玩家";
translations["MSG_PARENT_PAGE_LAUNCH_APP"] = "启动应用";
translations["MSG_PARENT_PAGE_NO_PLAYER_WARNING_TITLE"] = "没有玩家";
translations["MSG_PARENT_PAGE_NO_PLAYER_WARNING_MESSAGE"] = "请先添加一个玩家才能启动应用。";

// CreatePlayerModal
translations["MSG_PARENT_PAGE_CREATE_PLAYER_TITLE"] = "添加玩家";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_ICON_TITLE"] = "选择头像";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_CONFIRM_TITLE"] = "确认";
translations["MSG_TOAST_CREATE_PLAYER_SUCCESS"] = "玩家添加成功";
translations["MSG_CREATE_USER_PREVIEW_MESSAGE_BY_PARENT"] = "使用此信息注册玩家";
translations["MSG_PRESET_ICON_TITLE_BY_PARENT"] = "选择头像";
translations["MSG_ICON_CATEGORY_ALL_BY_PARENT"] = "全部";
translations["MSG_UPLOAD_ICON_DRAG_DROP_BY_PARENT"] = "将图片拖放到这里";
translations["MSG_UPLOAD_ICON_CLICK_BY_PARENT"] = "或点击选择图片";
translations["MSG_UPLOAD_ICON_REMOVE_BY_PARENT"] = "删除";
translations["MSG_UPLOAD_ICON_TYPE_ERROR"] = "请选择 JPG 或 PNG 格式的图片";
translations["MSG_UPLOAD_ICON_SIZE_ERROR"] = "文件大小必须在 5MB 以下";
translations["MSG_SELECT_PLACEHOLDER"] = "请选择";
translations["MSG_COLOR_SELECT_SHADE_BY_PARENT"] = "选择喜欢的色调";
translations["MSG_PROFILE_AI_APPEARANCE_BY_PARENT"] = "外观";

// CreatePlayerModal - 额外密钥（从主 i18n 复制）
translations["MSG_CREATE_USER_TITLE_GENDER_BY_PARENT"] = "孩子的性别";
translations["MSG_CREATE_USER_TITLE_BIRTHDAY_BY_PARENT"] = "孩子的生日";
translations["MSG_CREATE_USER_TITLE_PREVIEW_BY_PARENT"] = "确认注册信息";
translations["MSG_CREATE_USER_BTN_NEXT_BY_PARENT"] = "下一步";
translations["MSG_CREATE_USER_BTN_GENERATE_BY_PARENT"] = "生成头像";
translations["MSG_CREATE_USER_STEP_NAME_BY_PARENT"] = "名字";
translations["MSG_CREATE_USER_STEP_ICON_BY_PARENT"] = "头像";
translations["MSG_CREATE_USER_STEP_CONFIRM_BY_PARENT"] = "确认";
translations["MSG_USER_PROFILE_DEFAULT_NAME"] = "姓名%{random}";
translations["MSG_USER_PROFILE_INPUT_NAME_PROMPT_BY_PARENT"] = "请输入孩子的名字";
translations["MSG_PROFILE_AI_FAVORITE_COLOR_BY_PARENT"] = "喜欢的颜色";
translations["MSG_SUBJECT_LANGUAGE_BY_PARENT"] = "语文";
translations["MSG_SUBJECT_LIFE_BY_PARENT"] = "生活";
translations["MSG_SUBJECT_INTEGRATED_BY_PARENT"] = "综合";
translations["MSG_SUBJECT_SPECIAL_ACTIVITIES_BY_PARENT"] = "活动";

// CreatePlayerModal - 步骤标签
translations["MSG_PARENT_PAGE_CREATE_PLAYER_STEP_NAME"] = "名字";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_STEP_LANGUAGE"] = "语言";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_STEP_ICON"] = "头像";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_STEP_CONFIRM"] = "确认";
translations["MSG_CREATE_USER_TITLE_LANGUAGE_BY_PARENT"] = "请选择孩子的显示语言";
translations["MSG_USER_PROFILE_NAME_PLACEHOLDER_BY_PARENT"] = "孩子的名字";

// CreatePlayerModal - 子步骤标签（6步）
translations["MSG_PARENT_PAGE_CREATE_PLAYER_SUBSTEP_GENDER"] = "性别";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_SUBSTEP_BIRTHDAY"] = "生日";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_SUBSTEP_APPEARANCE"] = "外貌";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_SUBSTEP_COLOR"] = "喜欢的颜色";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_SUBSTEP_BEST_SUBJECT"] = "擅长的科目";
translations["MSG_PARENT_PAGE_CREATE_PLAYER_SUBSTEP_ICON"] = "头像";

// 素材删除
translations["MSG_PARENT_PAGE_PLAYER_ASSET_DELETE_BTN"] = "删除";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_DELETE_TITLE"] = "确定删除此素材？";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_DELETE_MESSAGE"] =
  "「%{name}」将被删除。\n删除后无法恢复。";

// 认证界面
translations["MSG_SIGN_IN_WITH_MAIL"] = "使用邮箱登录";
translations["MSG_SIGN_NO_ACCOUNT_REGISTER"] = "没有账号？立即注册";
translations["MSG_SIGN_PASSWORD_REQUIRED"] = "请输入密码";
translations["MSG_SIGN_LOGIN_FAILED"] = "邮箱地址或密码不正确。";
translations["MSG_SIGN_UP_BTN"] = "注册";
translations["MSG_SIGN_UP_WITH_MAIL"] = "使用邮箱注册";
translations["MSG_SIGN_ALREADY_ACCOUNT_LOGIN"] = "已有账号？立即登录";
translations["MSG_SIGN_PASSWORD_MISMATCH"] = "密码不匹配";
translations["MSG_SIGN_UP_EMAIL_ALREADY_EXISTS_FAILED_MESSAGE"] =
  "该邮箱已被注册。请尝试其他邮箱地址。";
translations["MSG_SIGN_UP_FAILED"] = "账号创建失败。请重试。";
translations["MSG_SIGN_UP_SUCCESS_CONTENT"] = "账号注册成功。";
translations["MSG_SIGN_UP_WITH_APPLE"] = "使用 Apple 继续";
translations["MSG_SIGN_USER_MAIL"] = "邮箱地址";
translations["MSG_SIGN_USER_PASSWORD_CONFIRM"] = "确认密码";
translations["MSG_SIGN_EMAIL_REQUIRED"] = "请输入邮箱地址";
translations["MSG_SIGN_EMAIL_INVALID"] = "请输入有效的邮箱地址";
translations["MSG_SIGN_IN_FORGOT_PASSWORD_TITLE"] = "重置密码";
translations["MSG_SIGN_BACK_TO_LOGIN"] = "返回登录";
translations["MSG_PARENTS_PROFILE_DEFAULT_NAME"] = "家长";

// 删除账户模态框
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_DESC_PREFIX"] =
  "如果您希望删除已注册的账户，请点击";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_CLICK_HERE"] = "这里";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_DESC_SUFFIX"] = "。";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_OPTION_1"] = "现在不（定期）使用了";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_OPTION_2"] = "内容不足";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_OPTION_3"] = "应用程序难以操作";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_OPTION_4"] = "启动和游玩速度太慢";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_OPTION_5"] = "通知太烦人";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_OPTION_6"] = "其他";
translations["MSG_NEXT_BTN"] = "下一步";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_FEEDBACK_LABEL"] =
  "如有其他意见请告诉我们（可选）";

// 方案对比表 - 玩家数
translations["MSG_PARENT_PAGE_USERS_FREE"] = "2人";
translations["MSG_PARENT_PAGE_USERS_STANDARD"] = "4人";
translations["MSG_PARENT_PAGE_USERS_PREMIUM"] = "8人";

// 恢复购买
translations["MSG_SUBSCRIPTION_RESTORE_BTN"] = "恢复购买";
translations["MSG_SUBSCRIPTION_RESTORE_SUCCESS_TITLE"] = "恢复完成";
translations["MSG_SUBSCRIPTION_RESTORE_SUCCESS_MESSAGE"] = "已恢复您的购买信息";

// 家长资料 - 您的角色
translations["MSG_USER_ROLE_TITLE"] = "您";

// 配饰
translations["MSG_ACCESSORY_TITLE_BY_PARENT"] = "配饰";
translations["MSG_ACCESSORY_NONE_BY_PARENT"] = "无";
translations["MSG_ACCESSORY_MEGANE_BY_PARENT"] = "眼镜";
translations["MSG_ACCESSORY_BOUSHI_BY_PARENT"] = "帽子";
translations["MSG_ACCESSORY_HAIRPIN_BY_PARENT"] = "发夹";
translations["MSG_ACCESSORY_RIBBON_BY_PARENT"] = "蝴蝶结";
translations["MSG_ACCESSORY_BANDAID_BY_PARENT"] = "创可贴";
translations["MSG_PARENT_PAGE_EDIT_ACCESSORY"] = "编辑配饰";

// 通用按钮（从 common/i18n 迁移）
translations["MSG_CONFIRM_BTN"] = "确定";
translations["MSG_STOP_BTN"] = "停止";
translations["MSG_DELETE_BTN"] = "删除";
translations["MSG_CLOSE_BTN"] = "关闭";
translations["MSG_CURRENT_PLAN"] = "当前套餐";

// 套餐名称（非PARENT版）
translations["MSG_PLAN_TRIAL"] = "体验";
translations["MSG_PLAN_FREE"] = "免费";
translations["MSG_PLAN_STANDARD"] = "基本";
translations["MSG_PLAN_PREMIUM"] = "高级";
translations["MSG_PLAN_BUILDER"] = "创作者";
translations["MSG_PLAN_EDUCATION"] = "教室";

// UpgradePromotion
translations["MSG_UPGRADE_PROMOTION_TITLE"] = "升级套餐，享受更多乐趣！";
translations["MSG_UPGRADE_PROMOTION_TABLE_PLAN"] = "套餐";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS"] = "玩家数";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS_TRIAL"] = "1人";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS_FREE"] = "2人";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS_STANDARD"] = "4人";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS_PREMIUM"] = "8人";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS"] = "作品数";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS_TRIAL"] = "1个";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS_FREE"] = "5个";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS_STANDARD"] = "10个";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS_PREMIUM"] = "10个";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE"] = "AI图片";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE_TRIAL"] = "每天1次";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE_FREE"] = "每天2次";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE_STANDARD"] = "每天10次";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE_PREMIUM"] = "无限制\n（同时3张）";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT"] = "学伴君";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT_TRIAL"] = "每天4次";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT_FREE"] = "每天8次";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT_STANDARD"] = "无限制";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT_PREMIUM"] = "无限制";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE"] = "数据存储容量";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE_TRIAL"] = "100MB";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE_FREE"] = "1GB";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE_STANDARD"] = "5GB";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE_PREMIUM"] = "50GB";
translations["MSG_UPGRADE_PROMOTION_CHANGE_BTN"] = "更改";
translations["MSG_LOGIN_REQUIRED_TITLE"] = "需要登录";
translations["MSG_LOGIN_REQUIRED_MESSAGE"] = "使用此功能需要注册账号。";

// Restricted Feature
translations["MSG_RESTRICTED_FEATURE_TITLE_COURSE"] = "课程无法使用";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_COURSE"] =
  "当前套餐只能游玩学习算法的关卡1和2。\n想要更多请询问家长。";
translations["MSG_RESTRICTED_FEATURE_TITLE_PROJECT_LIMIT"] = "作品数已达上限";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_PROJECT_LIMIT"] =
  "当前套餐最多可以创建%{limit}个作品。\n想要更多请询问家长。";
translations["MSG_RESTRICTED_FEATURE_TITLE_CHILD_USER_LIMIT"] = "玩家数已达上限";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_CHILD_USER_LIMIT"] =
  "当前套餐最多可以添加%{limit}位玩家。\n想要更多请询问家长。";
translations["MSG_RESTRICTED_FEATURE_TITLE_CHILD_USER_ADD_TRIAL"] = "无法添加玩家";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_CHILD_USER_ADD_TRIAL"] =
  "体验套餐无法添加玩家。\n想要添加玩家请询问家长。";
translations["MSG_RESTRICTED_FEATURE_TITLE_PARENT_SETTINGS"] = "此套餐无法使用";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_PARENT_SETTINGS"] =
  "体验套餐无法访问家长页面。\n需要注册家长账号。";
translations["MSG_RESTRICTED_FEATURE_TITLE_AI_CHAT_LIMIT"] = "今日AI聊天次数已用完";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_AI_CHAT_LIMIT"] =
  "当前套餐每天可使用%{limit}次。\n升级到基本套餐可无限使用。";
translations["MSG_RESTRICTED_FEATURE_TITLE_AI_IMAGE_LIMIT"] = "今日AI图片次数已用完";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_AI_IMAGE_LIMIT"] =
  "当前套餐每天可使用%{limit}次。\n升级到基本套餐可无限使用。";
translations["MSG_RESTRICTED_FEATURE_TITLE_CHAT_IMAGE"] = "关于图片功能";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_CHAT_IMAGE"] =
  "发送图片需要「扩展套餐」。\n升级到扩展套餐后可以发送图片。";
translations["MSG_RESTRICTED_FEATURE_TITLE_ASSET_LIMIT"] = "素材数已达上限";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_ASSET_LIMIT"] =
  "当前套餐最多可使用%{limit}个素材。\n升级到基本套餐可无限使用。";
translations["MSG_RESTRICTED_FEATURE_BTN_TO_PARENTS"] = "给家长";
translations["MSG_GUEST_LOGIN_PROMPT_TITLE"] = "需要注册账号";
translations["MSG_GUEST_LOGIN_PROMPT_MESSAGE"] = "使用此功能需要注册账号。";

// Asset
translations["MSG_ASSET_DELETE_BTN"] = "删除";
translations["MSG_CREATOR_ASSET_DELETE_WARNING_TITLE"] = "确定删除此素材？";
translations["MSG_CREATOR_ASSET_DELETE_WARNING_MESSAGE"] =
  "「%{name}」将被删除。此操作无法撤销。";
translations["MSG_CREATOR_APP_NAME_PLACEHOLDER"] = "输入名称";
translations["MSG_CREATOR_MENU_ASSET_CATEGORY_ALBUM_TITLE"] = "相册";
translations["MSG_CREATOR_MENU_ASSET_CATEGORY_DRAWING_TITLE"] = "绘画";
translations["MSG_USER_STOCK_AI_TAB"] = "AI";
translations["MSG_USER_STOCK_AI_EMPTY"] = "还没有AI生成的素材";
translations["MSG_ASSET_ALBUM_EMPTY_MESSAGE"] = "相册中没有图片";
translations["MSG_ASSET_DRAWING_EMPTY_MESSAGE"] = "还没有绘画作品";
translations["MSG_ASSET_ALBUM_ADD_TITLE"] = "添加";
translations["MSG_AI_TAB_GENERATE"] = "用AI创作";

// Chat
translations["MSG_USER_PROFILE_MESSAGE_PARENTS_TALK_WELCOME_TEXT"] = " 加入了。";

// ParentGate
translations["MSG_PARENT_GATE_WARNING"] = "给家长";
translations["MSG_PARENT_GATE_TITLE"] = "以下内容请由家长操作";

// Auth
translations["MSG_AUTH_SELECTION_INSTRUCTION"] =
  "已有账号请选择「登录」，新用户请选择「注册」。";
translations["MSG_AUTH_SIGN_IN"] = "登录";
translations["MSG_AUTH_SIGN_IN_DESC"] = "使用现有账号登录";
translations["MSG_AUTH_SIGN_UP"] = "注册";
translations["MSG_AUTH_SIGN_UP_DESC"] = "创建新账号";

// Misc
translations["MSG_BLOCKLY_INPUT_NUMBER_LIMIT"] = "请输入数字";
translations["MSG_ASSISTANT_STOP"] = "停止";

translations["MSG_SUBSCRIPTION_REQUEST_CTA_TITLE"] = "您的孩子发来了购买请求";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_BODY_WITH_PLAN"] = "%{name}希望购买「%{plan}」。";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_BODY_NO_PLAN"] = "%{name}希望购买付费方案。";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_BUY_BTN"] = "购买";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_VIEW_PLANS_BTN"] = "查看方案";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_PLAN_STANDARD"] = "基本方案";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_PLAN_PREMIUM"] = "特别方案";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_REMAINING_DAYS"] = "此请求将在%{days}天后过期。";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_REMAINING_TODAY"] = "此请求将于今天过期。";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_ALREADY_ACTIVE"] = "您已在使用付费方案。";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_ALREADY_ACTIVE_BTN"] = "使用中";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_EXPIRED"] = "此请求已过期。";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_EXPIRED_BTN"] = "已过期";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_SAFETY_NOTE"] = "点击按钮后会打开确认页面，不会立即扣款。";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_FEATURE_PROJECTS"] = "作品数量";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_FEATURE_AI_IMAGE"] = "AI图像";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_VALUE_PROJECTS"] = "%{count}个";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_FEATURE_AI_CHAT"] = "AI助手";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_FEATURE_AI_IMAGE_COUNT"] = "生成次数";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_FEATURE_AI_IMAGE_SIMULTANEOUS"] = "单次张数";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_FEATURE_STORAGE"] = "存储空间";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_VALUE_TIMES"] = "%{count}次";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_VALUE_SHEETS"] = "%{count}张";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_UNLIMITED"] = "无限制";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_MONTHLY"] = "每月 %{price}";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_ANNUAL"] = "每年 %{price}";
translations["MSG_SUBSCRIPTION_REQUEST_CTA_ANNUAL_DEAL"] = "省2个月";

export default translations;
